// removed by extract-text-webpack-plugin
module.exports = {"input":"DatePicker2__input___yiiO9","error":"DatePicker2__error___1iA4T","inputFeedback":"DatePicker2__inputFeedback___3UzFY"};


//////////////////
// WEBPACK FOOTER
// ./src/components/common/datepicker/DatePicker2.scss
// module id = 1268
// module chunks = 0